import { useProcurifyIntl, useFeatureFlag } from '@webapp/hooks'
import { BudgetCategoryTypes } from '@webapp/models/enums/BudgetCategoryType'
import { type BudgetCategoryTypeOption } from '../BudgetCategoryTypeSelect'
import messages from '../messages'

export const useBudgetCategoryTypeOptions = () => {
  const intl = useProcurifyIntl()
  const FT_5817_ENABLE_BUDGETS_REDESIGN = useFeatureFlag(
    'FT_5817_ENABLE_BUDGETS_REDESIGN'
  )

  const budgetCategoryTypeOptions: BudgetCategoryTypeOption[] = [
    {
      label: intl.formatMessage(
        FT_5817_ENABLE_BUDGETS_REDESIGN
          ? messages.allBudgets
          : messages.allBudgetCategories
      ),
      value: BudgetCategoryTypes.ALL,
    },
    {
      label: intl.formatMessage(messages.onlySourceOfTruthBudgetCategories),
      value: BudgetCategoryTypes.INCLUDE_SOURCE_OF_TRUTH,
    },
    {
      label: intl.formatMessage(messages.excludeSourceOfTruthBudgetCategories),
      value: BudgetCategoryTypes.EXCLUDE_SOURCE_OF_TRUTH,
    },
  ]

  return budgetCategoryTypeOptions
}
